import React, { useContext } from "react";
import ResponsiveAccordion from "../ResponsiveAccordion/ResponsiveAccordion";
import { Row, Col, Container } from "react-bootstrap";

import GeneralInfo from "../TreeFormCard/GeneralInfo";
import Photos from "../TreeFormCard/EditPhotos/Photos";
import SiteConditions from "../TreeFormCard/SiteConditions";
import TreeCharacteristics from "../TreeFormCard/TreeChar";
import Considerations from "../TreeFormCard/Considerations";
import TextInput from "../FormField/TextInput";
import Taxons from "../TreeFormCard/EditTaxon/Taxons";
import Commons from "../TreeFormCard/EditCommon/Commons";

import MenuInput from "../FormField/MenuInput";
import { useSelector } from "react-redux";
import { EditTreeContext } from "./EditTreeV2";
import "../FormField/FormField.css";
import ExternalResources from "../TreeFormCard/ExternalResources";

function Layout(props) {
  let children = props.children;
  if (!Array.isArray(children)) {
    children = [children];
  }
  return (
    <div>
      <Row>
        {children &&
          children.map(child => (
            <Col sm={12} className="mb-4">
              {child}
            </Col>
          ))}
      </Row>
    </div>
  );
}

function NameInfoV2(props) {
  const searchCharacteristics = useSelector(
    state => state.searchCharacteristics.data
  );
  const treeDetail = useSelector(state => state.treeDetail);
  const editTree = useContext(EditTreeContext);

  if (!treeDetail || !editTree || !searchCharacteristics) {
    return <div>loading</div>;
  }

  return (
    <Container className="search-by-char-card--site-conditions">
      <Row>
        <Col lg={8}>
          <div>
            <Taxons />
          </div>

          <div>
            <Commons />
          </div>
        </Col>

        <Col lg={4}>
          <TextInput
            label="Family Name"
            name="family"
            defaultValue={treeDetail.family}
          />

          <MenuInput
            label="Generic Common Name(s)"
            name="genericCommonNames"
            defaultValue={treeDetail.genericCommonNames}
            options={searchCharacteristics.genericCommonNames}
            getOptionLabel={x => x}
            getOptionValue={x => x}
            onChange={v => props.handleForm("genericCommonNames", v)}
            isClearable={true}
            isMulti={true}
          />
        </Col>
      </Row>
    </Container>
  );
}

function TreeForm(props) {
  return (
    <Layout>
      <ResponsiveAccordion title="Name Information">
        <NameInfoV2 state={props.state} handleForm={props.handleForm} />
      </ResponsiveAccordion>

      <ResponsiveAccordion title="General Information">
        <GeneralInfo parentComponent={props} />
      </ResponsiveAccordion>

      <ResponsiveAccordion title="Photos">
        <Photos parentComponent={props} />
      </ResponsiveAccordion>

      <ResponsiveAccordion title="Tree Characteristics">
        <TreeCharacteristics parentComponent={props} />
      </ResponsiveAccordion>

      <ResponsiveAccordion title="Site Conditions">
        <SiteConditions parentComponent={props} />
      </ResponsiveAccordion>

      <ResponsiveAccordion title="Considerations">
        <Considerations parentComponent={props} />
      </ResponsiveAccordion>

      <ResponsiveAccordion title="External Resources">
        <ExternalResources />
      </ResponsiveAccordion>
    </Layout>
  );
}

export default TreeForm;
